export const COUNTRY_OPTIONS = [
  {
    id: 'AT',
    name: 'Austria',
  },
  {
    id: 'BE',
    name: 'Belgium',
  },
  {
    id: 'BG',
    name: 'Bulgaria',
  },
  {
    id: 'HR',
    name: 'Croatia',
  },
  {
    id: 'CY',
    name: 'Cyprus',
  },
  {
    id: 'CZ',
    name: 'Czechia',
  },
  {
    id: 'DK',
    name: 'Denmark',
  },
  {
    id: 'EE',
    name: 'Estonia',
  },
  {
    id: 'FI',
    name: 'Finland',
  },
  {
    id: 'FR',
    name: 'France',
  },
  {
    id: 'DE',
    name: 'Germany',
  },
  {
    id: 'GR',
    name: 'Greece',
  },
  {
    id: 'HU',
    name: 'Hungary',
  },
  {
    id: 'IS',
    name: 'Iceland',
  },
  {
    id: 'IE',
    name: 'Ireland',
  },
  {
    id: 'IT',
    name: 'Italy',
  },
  {
    id: 'LV',
    name: 'Latvia',
  },
  {
    id: 'LI',
    name: 'Liechtenstein',
  },
  {
    id: 'LT',
    name: 'Lithuania',
  },
  {
    id: 'LU',
    name: 'Luxembourg',
  },
  {
    id: 'MT',
    name: 'Malta',
  },
  {
    id: 'NL',
    name: 'Netherlands',
  },
  {
    id: 'NO',
    name: 'Norway',
  },
  {
    id: 'PL',
    name: 'Poland',
  },
  {
    id: 'PT',
    name: 'Portugal',
  },
  {
    id: 'RO',
    name: 'Romania',
  },
  {
    id: 'SK',
    name: 'Slovakia',
  },
  {
    id: 'SI',
    name: 'Slovenia',
  },
  {
    id: 'ES',
    name: 'Spain',
  },
  {
    id: 'SE',
    name: 'Sweden',
  },
  {
    id: 'GB',
    name: 'United Kingdom',
  },
];
